/* Svensk katalog for locale-manual-preview-no.js.
 * N\u00f8kler som mangler her, vises p\u00e5 engelsk. */
window.PlummeI18n.register('sv', {
  'manualPreview.reset': '\u00c5terst\u00e4ll',
  'manualPreview.title': 'Bokf\u00f6ring',
  'manualPreview.details': 'Detaljer',
  'manualPreview.summary': 'Sammanfattning per konto',
  'manualPreview.date': 'Datum',
  'manualPreview.account': 'Konto',
  'manualPreview.vat': 'Momskod',
  'manualPreview.before': 'Saldo f\u00f6re',
  'manualPreview.amount': 'Belopp',
  'manualPreview.after': 'Saldo efter',
  'manualPreview.debit': 'Debet',
  'manualPreview.credit': 'Kredit',
  'manualPreview.net': 'Nettof\u00f6r\u00e4ndring',
  'manualPreview.warning.balances': 'Saldon \u00e4r inte tillg\u00e4ngliga fr\u00e5n redovisningsunderlaget. Konteringarna visas utan saldo f\u00f6re och efter.',
  'manualPreview.warning.editing': 'Vid korrigering visas ers\u00e4ttningskonteringen h\u00e4r. Saldo f\u00f6re och efter visas inte, eftersom korrigeringen \u00e4ven kan \u00e5terf\u00f6ra en tidigare verifikation.',
  'manualPreview.warning.years': 'Konteringarna str\u00e4cker sig \u00f6ver flera kalender\u00e5r. Bokf\u00f6ringsraderna visas, men saldo f\u00f6re och efter ber\u00e4knas inte \u00f6ver \u00e5rsgr\u00e4nser.',
  'manualPreview.warning.country': 'F\u00f6rhandsgranskningen saknar redovisningsland eller st\u00f6der inte den valda momshanteringen f\u00f6r landet.',
});
